import React from 'react';
/** import third-party libraries in the section above, keep the ascending order */

import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
/** import mui components in the section above, keep the ascending order */

import Spacer from 'widgets-v5/spacer';
/** import widgets components in the section above, keep the ascending order */

const InfoAlertDealPrice = ({}) => {
    return (
        <React.Fragment>
            <Grid>
                <Spacer type="small" />
                <Box>
                    <Alert severity="info">
                        Price should be managed according to the terms of the guaranteed deal.
                        <br />
                        Any settings and/or changes should be coordinated with the publisher.
                    </Alert>
                </Box>
            </Grid>
        </React.Fragment>
    );
};

export default InfoAlertDealPrice;
